module.exports = __webpack_public_path__ + "img/限时商品1.43d487ed.png";